import { UpdateStartoverDataStream } from '@smart-tv/typings/content';
import { kmm } from './kmm';
import { StartOverData } from '@norlys-a-s/norlys-play-kmm/kotlin/NorlysPlay_KMM-shared.mjs';

const responseMapper = (data: StartOverData): UpdateStartoverDataStream => {
  return {
    title: data.title ?? '',
    subtitle: data.subtitle ?? '',
    updateStartoverNextInSecs: data.updateStartOverNextInSec
  };
};

export const updateStartoverData = async (sid: number): Promise<UpdateStartoverDataStream> => {
  const data = await kmm((repo) => repo.updateStartOverData(sid));
  return responseMapper(data);
};
